import React from 'react';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-padding bg-gray">
      <div className="container text-center">
        <div className="section-header">
          <h2 className="section-title lang-en">How It Works</h2>
          <h2 className="section-title lang-ar" style={{ display: 'none' }}>كيف يعمل النظام</h2>
          <div className="shape"></div>
        </div>

        <div className="row mt-4">
          <div className="col-md-4">
            <div className="how-box">
              <div className="icon mb-2"><i className="lni-user"></i></div>
              <h4 className="lang-en">1. Register your company</h4>
              <h4 className="lang-ar" style={{ display: 'none' }}>1. سجّل شركتك</h4>
              <p className="lang-en">Get a dedicated subdomain and company workspace in minutes.</p>
              <p className="lang-ar" style={{ display: 'none' }}>الحصول على نطاق فرعي ومساحة عمل للشركة في دقائق.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="how-box">
              <div className="icon mb-2"><i className="lni-cog"></i></div>
              <h4 className="lang-en">2. Add staff & kitchen</h4>
              <h4 className="lang-ar" style={{ display: 'none' }}>2. أضف الموظفين والمطبخ</h4>
              <p className="lang-en">Configure menus, points, access roles and stock units.</p>
              <p className="lang-ar" style={{ display: 'none' }}>اضبط القوائم، النقاط، الصلاحيات، ووحدات التخزين.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="how-box">
              <div className="icon mb-2"><i className="lni-reload"></i></div>
              <h4 className="lang-en">3. Start ordering</h4>
              <h4 className="lang-ar" style={{ display: 'none' }}>3. ابدأ الطلبات</h4>
              <p className="lang-en">Employees place orders; kitchen receives live updates and prepares instantly.</p>
              <p className="lang-ar" style={{ display: 'none' }}>الموظفون يطلبون والمطبخ يستقبل التحديثات فورياً ويجهز الطلبات.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;